import Layout from "../_layout.js";

export default function Nieruchomosci(props) {
  let Miasto = props.miasto;
  let Podatek = props.podatek;

  return (
    <>
      <Layout miasto={Miasto} podatek={Podatek} />
    </>
  );
}
